import { useAuth } from "../auth/AuthProvider";

/**
 * Pre-launch splash shown to everyone except the admin (and the `?preview=1`
 * bypass). Keeps the literary/absurdist tone of the product. A discreet "enter"
 * link triggers Google sign-in so the admin can get through; a signed-in
 * non-admin gets a gentle "not yet" note and a way back out.
 */
export function ComingSoon() {
  const { user, signIn, signOut } = useAuth();
  const firstName = user?.name?.split(" ")[0];

  return (
    <div className="coming">
      <div className="coming__card">
        <div className="coming__mark">three heads</div>
        <h1 className="coming__title">We're building something.</h1>
        <p className="coming__lead">
          Whether it will amount to anything is, naturally, still under debate.
        </p>
        <p className="coming__voices">
          Camus shrugs. Dostoevsky frets. Kafka files the appropriate forms.
        </p>
        <p className="coming__sub">Back soon. The absurd takes time.</p>

        {user ? (
          <p className="coming__note">
            You're early{firstName ? `, ${firstName}` : ""} — the doors aren't open yet.{" "}
            <button className="coming__link" onClick={signOut}>
              sign out
            </button>
          </p>
        ) : (
          <button className="coming__enter" onClick={signIn}>
            enter
          </button>
        )}
      </div>
    </div>
  );
}
